/**
 * @copyright 2019 @ DigiNet
 * @author TRIHAO
 * @create 10/25/2019
 * @Example
 */

import React from "react";
import {Collapse, Fade, Grow, Slide} from "@material-ui/core";

export const popupTransitions = {
    Slide: React.forwardRef(function Transition(props, ref) {
        return <Slide direction="up" ref={ref} {...props} />;
    }),
    Grow: React.forwardRef(function Transition(props, ref) {
        return <Grow ref={ref} {...props} />;
    }),
    Fade: React.forwardRef(function Transition(props, ref) {
        return <Fade ref={ref} {...props} />;
    }),
    Collapse: React.forwardRef(function Transition(props, ref) {
        return <Collapse ref={ref} {...props} />;
    })
};

export function getExtFile(fileName) {
    if (!fileName) return "";
    const arrNames = fileName.split('.');
    return arrNames.length > 1 ? arrNames[arrNames.length - 1] : "";
}

export function getFileInfomations(files) {
    if (Array.isArray(files)) {
        if (files.length > 0) {
            let _files = [];
            files.forEach((_f) => {
                const _convertedFile = {
                    ..._f,
                    fileName: _f.FileName ? _f.FileName : (_f.name ? _f.name : (_f.fileName ? _f.fileName : "")),
                    fileExt: _f.FileExt ? _f.FileExt : (_f.ext ? _f.ext : (_f.fileExt ? _f.fileExt : "")),
                    fileType: _f.FileType ? _f.FileType : (_f.type ? _f.type : (_f.fileType ? _f.fileType : "")),
                    fileSize: _f.FileSize ? _f.FileSize : (_f.size ? _f.size : (_f.fileSize ? _f.fileSize : "")),
                    url: _f.URL ? _f.URL : (_f.url ? _f.url : ""),
                };
                _files.push(_convertedFile);
            });
            return _files;
        }
    } else {
        return {
            ...files,
            fileName: files.FileName ? files.FileName : (files.name ? files.name : (files.fileName ? files.fileName : "")),
            fileExt: files.FileExt ? files.FileExt : (files.ext ? files.ext : (files.fileExt ? files.fileExt : "")),
            fileType: files.FileType ? files.FileType : (files.type ? files.type : (files.fileType ? files.fileType : "")),
            fileSize: files.FileSize ? files.FileSize : (files.size ? files.size : (files.fileSize ? files.fileSize : "")),
            url: files.URL ? files.URL : (files.url ? files.url : ""),
        };
    }
    return [];
}